import React, { useEffect, useContext, useState } from 'react';
import axiosConfig from '../../../../utils/axiosConfig';
import { makeStyles } from '@material-ui/core/styles';

import { Box, Divider, Grid, IconButton, Menu, MenuItem, Tooltip, Typography } from '@material-ui/core';
import { MoreVert as MoreVertIcon } from '@material-ui/icons';
import ClassworkItem from './ClassworkItem/ClassworkItem';
import TopicModal from '../Modals/TopicModal';

import { StateContext, DispatchContext } from '../../../../context/Provider';
import ConfirmPasswordModal from '../../../../components/Shared/ConfirmPasswordModal';

// This example uses theme overrides to define responsive Typography styles
// for different screen sizes.
// @see https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/styles/createTypography.js
function pxToRem(value) {
    return `${value / 16}rem`;
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    moreVertIcon: {},
    divider: {
        background: theme.palette.primary.main
    },
    topicTitle: {
        // color: 'red',
        // fontSize: '1.25',
        // [theme.breakpoints.up("md")]: {
        //     fontSize: pxToRem(24)
        // },

        [theme.breakpoints.down("xs")]: {
            fontSize: pxToRem(14),
            // color: 'black'
        }
    }
}));

const ClassworkTopic = (props) => {

    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);

    const { authState, globalState } = appState;
    const { globalDispatch } = appDispatch;

    const classes = useStyles();

    // for controlled accordion
    const [expanded, setExpanded] = useState(false);
    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    // for menu popover
    const [anchorEl, setAnchorEl] = useState(null);
    const openDropdown = Boolean(anchorEl);

    const handleMenu = (event) => {
        event.stopPropagation();
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const [topicModalOpen, setTopicModalOpen] = useState(false);
    const handleTopicModalOpen = () => {
        setTopicModalOpen(true);
    }

    const handleTopicModalClose = () => {
        setTopicModalOpen(false);
    }

    const [classworks, setClassworks] = useState([]);

    async function fetchClassworks() {

        try {
            const response = await axiosConfig.get(`/classworks?topic_id=${props.topicID}`);
            const { data } = response.data;
            setClassworks(data);
        } catch(e) {
            console.log(e);
        }
    }

    async function removeTopic(topicID) {

        globalDispatch({type: 'setIsLoading', value: true});

        try {
            const response = await axiosConfig.post(`/topics/${topicID}`, {
                _method: "DELETE"
            });

            const { status_code, message } = response.data;

            if (status_code === 'ok') {
                console.log(message);
                props.fetchTopics(props.showActiveClassworks);
            }

        } catch (e) {
            console.log(e);
        }

        globalDispatch({type: 'setIsLoading', value: false});
    }

    async function updateVisibility (topicID, visibility = 'hide') {
        globalDispatch({type: 'setIsLoading', value: true});

        try {

            const response = await axiosConfig.post(`/topics/${topicID}/update-visibility`, {
                visibility: visibility
            });

            const { status_code, message } = response.data;

            if (status_code === 'ok') {
                console.log(message);
                props.fetchTopics();
            }

        } catch (e) {
            console.log(e);
        }

        globalDispatch({type: 'setIsLoading', value: false});
    }

    const reloadBrowser = () => {
        window.location.reload();
    }

    const [openConfirmPasswordDialog, setOpenConfirmPasswordDialog] = useState(false)
    const [deletingTopic, setDeletingTopic] = useState(null)

    const closeConfirmPasswordDialog = () => {
        setOpenConfirmPasswordDialog(false)
    }

    const passwordDialogConfirmed = (entityId) => {
        removeTopic(entityId);
        setOpenConfirmPasswordDialog(false)
    }

    useEffect(() => {

        const source = axiosConfig.CancelToken.source();
        fetchClassworks();
        return () => {
            source.cancel();
        }

    }, [globalState.isLoading]);

    return (
        <>
            <ConfirmPasswordModal
                title="Please confirm your password"
                message="Deleting this topic will also delete all the lessons in this topic. To confirm this action, please enter your password."
                dialogState={openConfirmPasswordDialog}
                closeDialog={closeConfirmPasswordDialog}
                dialogConfirmed={(participant) => {
                    passwordDialogConfirmed(participant);
                }}
                participantId={deletingTopic}
            />

            <Grid item xs={12} sm={12} md={12} lg={12} xl={10}>

                { topicModalOpen ? (
                    <TopicModal
                        open={topicModalOpen}
                        handleClose={handleTopicModalClose}
                        dialogTitle={`Edit Topic`}
                        topicID={props.topicID}
                        topic={props.topic}
                        fetchTopics={props.fetchTopics}
                    />
                    ) : null
                }

                <Box mb={1}>
                    <Grid style={{display:"flex", justifyContent:"space-between"}}>
                        <Box pt={1}>
                            <Typography
                                variant="h6"
                                color="primary"
                                className={classes.topicTitle}
                            >
                                {props.topic.title}
                            </Typography>
                        </Box>
                        {authState.user.role_id === 4 ? (
                            <IconButton
                                aria-label="edit"
                                onClick={handleMenu}
                                style={{ backgroundColor: 'transparent' }}
                            >
                                <Tooltip title="Select Option">
                                    <MoreVertIcon className={classes.moreVertIcon} />
                                </Tooltip>
                            </IconButton>
                        ) : null}
                    </Grid>

                    <Menu
                        id="menu-cardheader"
                        anchorEl={anchorEl}
                        getContentAnchorEl={null} // this will display the popover below the icon
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left"
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "center"
                        }}
                        open={openDropdown}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={() => { handleClose(); handleTopicModalOpen(); }}>Rename Topic</MenuItem>
                        {authState.user.role_id === 4 && props.topic.is_hidden == false
                            ? <MenuItem onClick={() => { handleClose(); updateVisibility(props.topic.id, 'hide') }}>Hide Topic</MenuItem>
                            : <MenuItem onClick={() => { handleClose(); updateVisibility(props.topic.id, 'show') }}>Show Topic</MenuItem>
                        }
                        <MenuItem onClick={() => {
                            setDeletingTopic(props.topic.id)
                            setOpenConfirmPasswordDialog(true)
                        }}>
                            Delete
                        </MenuItem>
                    </Menu>

                    <Divider className={classes.divider} />
                </Box>

                <Box mb={2}></Box>

                <div className={classes.root}>
                    {classworks ? classworks.map((classwork, i) => (
                        <ClassworkItem
                            key={classwork.id}
                            expanded={expanded}
                            handleChange={handleChange}
                            classcode={props.classcode}
                            classworkID={classwork.id}
                            title={classwork.title}
                            description={classwork.description}
                            turnedIn={classwork.turned_in}
                            assigned={classwork.assigned}
                            isGraded={classwork.is_graded}
                            isPublished={classwork.is_published}
                            fetchClassworks={fetchClassworks}
                        />
                    )) : reloadBrowser() }
                </div>
            </Grid>
        </>
    );
}

export default ClassworkTopic;